import {observer} from "mobx-react";
import React from "react";
import {FormProps} from "../../core/form/formUtils";
import {DefinitionType} from "../../core/form/form";
import {MdCheckbox, MdTextField} from "../../core/components/fields/fields";
import {Validate} from "../../core/form/validate";
import {createForm} from "../../core/form/createForm";
import ProjectVersionParking from "../domain/project/projectVersionParkingDomain";

@observer
class ProjectVersionParkingForm extends React.Component<FormProps<ProjectVersionParking, ProjectVersionParking>, any> {

  render() {
    let {dataObject} = this.props;
    let fields = dataObject.getFormFields(ProjectVersionParkingFormDefinition.formName);
    let {parkingName, value,controlledCo,chargingStations,carsharing} = fields;
    return (
      <div>
        <div className='row'>
          <div className='fx col-xs-6 col-sm-6'>
            <MdTextField {...parkingName.props}/>
            <Validate field={parkingName} value={parkingName.props.value} />
          </div>
          <div className='fx col-xs-6 col-sm-6'>
            <MdTextField {...value.props} />
            <Validate field={value} value={value.props.value}/>
          </div>
        </div>
        <div className='row'>
          <div className='fx col-xs-4 col-sm-4'>
            <MdCheckbox {...controlledCo.props} />
            <Validate field={controlledCo} value={controlledCo.props.value}/>
        </div>
          <div className='fx col-xs-4 col-sm-4'>
            <MdCheckbox {...chargingStations.props} />
            <Validate field={chargingStations} value={chargingStations.props.value} />
          </div>
          <div className='fx col-xs-4 col-sm-4'>
            <MdCheckbox {...carsharing.props} />
            <Validate field={carsharing} value={carsharing.props.value}/>
          </div>
        </div>
      </div>
    );
  }
}


export const ProjectVersionParkingFormDefinition: DefinitionType = {
  formName: 'ProjectVersionParkingForm',
  fields: [
    {name : 'parkingName', validators: ['IsRequired']},
    {name : 'value', validators: ['IsRequired']},
    {name : 'controlledCo'},
    {name : 'chargingStations'},
    {name : 'carsharing'},

  ]
};

export default createForm(ProjectVersionParkingFormDefinition, null)(ProjectVersionParkingForm);



// WEBPACK FOOTER //
// ./src/sbtool/component/projectVersionParkingForm.tsx